module.exports = __webpack_public_path__ + "static/media/tab-puffs-crunchy.a2b8560e.png";